import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Avatar,
  FormHelperText,
  TextField,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { SelectOffice } from "../Include/DynamicSelect";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_USER, UPDATE_USER } from "../../Schema/User";
import { SelectMainUser } from "../Include/DynamicSelect";

export default function CreateForm({
  dialogTitle,
  editData,
  open,
  handleClose,
  setRefetch,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [selectOffice, setSelectedOffice] = useState({ id: "", title: "" });
  const [userValue, setUserValue] = useState({
    title: "",
    mainUserId: "",
    imageSrc: "",
  });

  //======================== Create User =========================
  const [createUser] = useMutation(CREATE_USER, {
    onCompleted: ({ createUser }) => {
      setLoading(false);
      if (createUser?.status) {
        setAlert(true, "success", createUser?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", createUser?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //======================== Update User =========================
  const [updateUser] = useMutation(UPDATE_USER, {
    onCompleted: ({ updateUser }) => {
      setLoading(false);
      if (updateUser?.status) {
        setAlert(true, "success", updateUser?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updateUser?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    role: Yup.string()
      .required("required")
      .notOneOf(["Choose role"], "require"),
    officeId: Yup.string().required("required"),
    mainUserId: Yup.string().required("required"),
  });

  const formik = useFormik({
    initialValues: {
      role: "Choose role",
      mainUserId: "",
      officeId: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createUser({
          variables: {
            input: {
              ...values,
            },
          },
        });
      } else {
        console.log("values", { ...values });
        updateUser({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (dialogTitle === "Update") {
      setUserValue({
        title: editData?.mainUserId?.firstName + " " + editData?.mainUserId?.lastName,
        mainUserId: editData?.mainUserId?._id,
        imageSrc: editData?.mainUserId?.imageSrc,
      });
      setSelectedOffice({
        id: editData?.officeId?._id,
        title: editData?.officeId?.officeKhName,
      });
      setFieldValue("mainUserId", editData?.mainUserId?._id);
      setFieldValue("role", editData?.role);
      setFieldValue("officeId", editData?.officeId?._id);
    } else {
      resetForm();
      setUserValue({ mainUserId: "", title: "", imageSrc: "" });
      setSelectedOffice({ id: "", title: "" });
    }
  }, [open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {dialogTitle === "Create"
                ? "បង្កើតអ្នកប្រើប្រាស់"
                : "កែប្រែអ្នកប្រើប្រាស់"}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Box>
                  <Stack direction="row" justifyContent="center">
                    <Button component="label" className="btn-upload-user">
                      <Avatar
                        className="avater-image"
                        src={
                          editData
                            ? editData?.mainUserId?.imageSrc
                            : userValue?.imageSrc
                            ? userValue?.imageSrc
                            : EmptyImage
                        }
                      />
                    </Button>
                  </Stack>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">អ្នកប្រើប្រាស់</Typography>
                {editData ? (
                  <TextField
                    className="text-field"
                    fullWidth
                    size="small"
                    value={
                      editData?.mainUserId?.firstName +
                      " " +
                      editData?.mainUserId?.lastName
                    }
                  />
                ) : (
                  <SelectMainUser
                    selectedVal={userValue}
                    setSelectedVal={setUserValue}
                    errors={errors}
                    touched={touched}
                    setFieldValue={setFieldValue}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">ការិយាល័យ</Typography>
                <SelectOffice
                  isUse={true}
                  selectedVal={selectOffice}
                  setSelectedVal={setSelectedOffice}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  touched={touched}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">តួនាទី</Typography>
                <FormControl className="search-field" fullWidth size="small">
                  <Select
                    value={values?.role}
                    onChange={(e) => setFieldValue("role", e.target.value)}
                  >
                    <MenuItem value="Choose role">Choose role</MenuItem>
                    <MenuItem value="SuperAdmin">SuperAdmin</MenuItem>
                    <MenuItem value="StockController">StockController</MenuItem>
                    <MenuItem value="Proposer">Proposer</MenuItem>
                  </Select>
                  {Boolean(touched.role && errors.role) && (
                    <FormHelperText sx={{ color: "red" }}>
                      {errors?.role}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Create" ? "បង្កើត" : "កែប្រែ"}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
